import {GridColor, MarkColor, GRID_ENUMS, COL_WIDTH, AGGREGATE_LEVELS, ChartLineColor} from './Styles.js';
import React from "react";
import Tooltip from "../common/Tooltip";
import IconButton from "../common/IconButton";
import OpenInNewIcon from "../common/icons/OpenInNewIcon";

export function cellStyle(params) {
    const color = numberToColor(params.value);
    return { backgroundColor: color };
}

export function cellStyleCorrect(params){
    let value = params.value;
    let styles;
    if(String(value).includes('%') || String(value).includes('skipped')){
        return cellStylePercentage(params);
    } else if((String(value) === '' || value === undefined) && params.skipped) {
    // } else if(String(value) === '') {
        return {
            backgroundColor: MarkColor.SKIPPED, color: MarkColor.SKIPPED, paddingLeft:'0!important', paddingRight:'0!important', borderRight:'1px solid #E8EDF1'
        }
    }

    // '0' for Difficulty Row
    if (String(value).includes(GRID_ENUMS.NOT_AVAILABLE) || params.node.data.userId === '0') {
        styles = {
            backgroundColor: 'inherit',
            color: 'inherit',
            textAlign: 'center',
            paddingLeft: '0!important',
            paddingRight: '0!important',
            borderRight: '1px solid #E8EDF1',
            borderBottom: '1px solid #E8EDF1',
            alignItems: 'center'
        };
    } else {
        const color = numberToCorrectColor(value);
        let fontColor = GridColor.WHITE;
        if (params.column.colDef.hideVal) {
            fontColor = color;
        }
        styles = {backgroundColor: color, color: fontColor, textAlign: 'center', borderRight: '1px solid #E8EDF1', alignItems: 'center'};
        if (!isNaN(value) && value !== 'skipped') {
            styles.cursor = 'pointer';
        }
    }
    return styles;

}

export function getAggregateLevelVal(aggregateLevel){
    let val = -1;
    if(AGGREGATE_LEVELS.SKILL === aggregateLevel){
        val = 4;
    }else if(AGGREGATE_LEVELS.CONCEPT === aggregateLevel){
        val = 3;
    }else if(AGGREGATE_LEVELS.TOPIC === aggregateLevel){
        val = 2;
    }else if(AGGREGATE_LEVELS.SYLLABUS === aggregateLevel){
        val = 1;
    }
    return val;
}

export function cellStylePercentage(params){
    let value = params.value;
    let styles;
    if(String(value).includes(GRID_ENUMS.NOT_AVAILABLE) || value === '') {
        styles = { backgroundColor: 'inherit', color: 'inherit',textAlign:'center', paddingLeft:'0!important', paddingRight:'0!important', borderRight:'1px solid #E8EDF1',alignItems:'center'}
        styles.color = GridColor.WHITE;
    }else if(String(value).includes('skipped')){
        styles = { backgroundColor: MarkColor.SKIPPED, color: MarkColor.SKIPPED,textAlign:'center', paddingLeft:'0!important', paddingRight:'0!important', borderRight:'1px solid #E8EDF1',alignItems:'center'}
        styles.cursor = 'pointer';
    }else{
        let val = value;
        if(typeof val === 'object' && val.hasOwnProperty('value')){
            val = val.value;
        }

        const color = numberToMarkColor(val);

        if (color !== GridColor.WHITE && params.data.name && params.data.name.disabled) {
            styles = { backgroundColor: GridColor.GREY, color: '#666', textAlign: 'center', borderRight:'1px solid #E8EDF1', alignItems:'center' };
        } else {
            let fontColor = GridColor.WHITE;
            if(params.column.colDef.hideVal){
                fontColor = color;
            }
            styles = { backgroundColor: color, color: fontColor, textAlign: 'center', borderRight:'1px solid #E8EDF1', alignItems:'center' };
            if(!isNaN(value)){
                styles.cursor = 'pointer';
            }
        }
    }
    return styles;
}

export function cellStyleGrowthPercentage(params){
    let value = params.value;
    let styles;
    if(String(value).includes(GRID_ENUMS.NOT_AVAILABLE) || value === ''){
        styles = { backgroundColor: 'inherit', color: 'inherit',textAlign:'center', paddingLeft:'0!important', paddingRight:'0!important', borderRight:'1px solid #E8EDF1',alignItems:'center'}
        styles.color = GridColor.WHITE;
    }else{
        let val = value;
        if(typeof val === 'object' && val.hasOwnProperty('value')){
            val = val.value;
        }

        const color = numberToMarkGrowthColor(val);
        // console.log('color: ',color);
        let fontColor = GridColor.WHITE;
        if(params.column.colDef.hideVal){
            fontColor = color;
        }
        styles = { backgroundColor: color, color: fontColor, textAlign: 'center', borderRight:'1px solid #E8EDF1', alignItems:'center' };
        if(!isNaN(value)){
            styles.cursor = 'pointer';
        }
    }
    return styles;
}

export function PercentageCell (params) {
    if (isNaN(params.value) || params.value === '') {
        return (
            <span></span>
        )
    }

    return (
        <span>{params.value}%</span>
    )
}
export function TimeCell (params) {
    return (
        <span>{convertSecondsToMinutesStr(params.value)}</span>
    )
}

export const calculateRoundPercent = (num, den) => {
    if (num === 0 || num === undefined || den === 0 || den === undefined) {
        return 0;
    }

    return Math.round(num / den * 100);
}

function numberToColor(val) {
    val = parseFloat(String(val).replace('%',''));
    if (val > 0) {
        return GridColor.GREEN;
    } else if (val === 0) {
        return GridColor.BLUE;
    } else if (val < 0){
        return GridColor.RED;
    } else {
        return GridColor.GREY;
    }
}

export function calculateDistance(x1, y1, x2, y2) {
    return Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
}

export function convertSecondsToMinutesStr(seconds, roundToMinutes = false) {
    if (seconds === undefined || isNaN(seconds)) {
        return '';
    }

    const minutes = Math.floor(Math.abs(seconds) / 60);
    const remainingSeconds = Math.abs(seconds) % 60;

    let result = '';

    if (roundToMinutes) {
        result = `${minutes} ${minutes === 1 ? 'min' : 'mins'}`;
    } else {
        result = `${minutes} ${minutes === 1 ? 'min' : 'mins'} ${remainingSeconds} ${remainingSeconds === 1 ? 'sec' : 'secs'}`;
    }

    // Add a negative sign if the original seconds value was negative
    if (seconds < 0) {
        result = '-' + result;
    }

    return result;
}

export function numberToCorrectColor(val) {
    val = parseFloat(String(val).replace('%',''));
    if (val === 0) {
        return MarkColor.INCORRECT;
    } else if (val >= 1) {
        return MarkColor.CORRECT;
    } else {
        return GridColor.WHITE;
    }
}

export function numberToMarkColor(val) {
    // console.log('val: ',val)
    if(val === undefined){
        return GridColor.WHITE;
    }
    val = parseFloat(String(val).replace('%',''));
    let color;

    if(val >= 80){
        color = MarkColor.mark80to100;
    }else if(val >= 60){
        color = MarkColor.mark60to79;
    }else if(val >= 30){
        color = MarkColor.mark30to59;
    }else{
        color = MarkColor.mark0to29;
    }
    return color;
}

export function numberToMarkGrowthColor(val) {
    // console.log('val: ',val)
    if(val === undefined){
        return GridColor.WHITE;
    }

    val = parseFloat(String(val).replace('%',''));

    let color;
    if(val === 0){
        color = ChartLineColor.STAGNANT;
    }else if(val > 0){
        color = ChartLineColor.INCLINE;
    }else{
        color = ChartLineColor.DECLINE;
    }
    return color;
}

export function rdmInt(min, max, not) {
    let val;
    if(!isNaN(not)){
        do{
            val = min + Math.floor( Math.random()*(max-min+1));
        }while(val === not);
    }else{
        val = min + Math.floor( Math.random()*(max-min+1));
    }
    return val;
}

export class PassCellRenderer {
    init(params) {
        this.eGui = document.createElement("div");
        this.eGui.innerHTML = `<span class="material-icons" style="font-size:20px;margin-top:-4px;">done</span>`;
    }
    getGui(params) {
        return this.eGui;
    }
}

export class FailCellRenderer {
    init(params) {
        this.eGui = document.createElement("div");
        this.eGui.innerHTML = `<span class="material-icons" style="font-size:20px;margin-top:-4px;">close</span>`;
    }
    getGui(params) {
        return this.eGui;
    }
}

export const addToArr = (value, arrVals, setFunc)=>{
    if(!arrVals.includes(value)){
        arrVals.push(value);
        setFunc(arrVals);
    }
}

export const removeFromArr = (value, arrVals, setFunc) => {
    for(let i = arrVals.length-1; i >= 0; i--){
        if(arrVals[i] === value){
            arrVals.splice(i,1);
            setFunc(arrVals);
            break;
        }
    }
}

export const sortArr  = (arr,attribute,direction)=> {
    if (direction === GRID_ENUMS.ASC) {
        arr.sort((colA,colB)=> {
            return colA[attribute] < colB[attribute] ? -1 : 1;
        });
    }else{
        arr.sort((colA,colB)=> {
            return colA[attribute] > colB[attribute] ? -1 : 1;
        });
    }
}

export const sortColumns = (columns,studentColOrder) =>{
    let studentColumns,
        studentUnansweredColumns = [],
        studentAnswerColumns = [],
        leftColumns = [],
        rightColumns = [];

    for (let c = 0; c < columns.length; c++) {
        let column = columns[c];

        if (column.columnType === 'user') {
            if (column.answered) {
                studentAnswerColumns.push(column);
            } else {
                studentUnansweredColumns.push(column);
            }
        } else if (column.pinned === 'left') {
            leftColumns.push(column);
        } else if (column.pinned === 'right') {
            rightColumns.push(column);
        }
    }

    studentColumns = [...studentAnswerColumns, ...studentUnansweredColumns];

    if (studentColOrder === GRID_ENUMS.LOWEST) {
        sortArr(studentAnswerColumns, 'performance', GRID_ENUMS.ASC);
        sortArr(studentUnansweredColumns, 'firstName', GRID_ENUMS.ASC);
        studentColumns = [...studentUnansweredColumns, ...studentAnswerColumns];
    } else if (studentColOrder === GRID_ENUMS.HIGHEST) {
        sortArr(studentAnswerColumns, 'performance', GRID_ENUMS.DESC);
        sortArr(studentUnansweredColumns, 'firstName', GRID_ENUMS.ASC);
        studentColumns = [...studentAnswerColumns, ...studentUnansweredColumns];
    } else if (studentColOrder === GRID_ENUMS.NAME_ASC) {
        sortArr(studentColumns,'firstName',GRID_ENUMS.ASC);
    }else if(studentColOrder === GRID_ENUMS.NAME_DESC){
        sortArr(studentColumns,'firstName',GRID_ENUMS.DESC);
    }

    sortArr(leftColumns, 'pinnedOrder', GRID_ENUMS.ASC);
    sortArr(rightColumns, 'pinnedOrder', GRID_ENUMS.ASC);

    return [...leftColumns, ...studentColumns, ...rightColumns];
}

export const showHideUserCols = (gridReference, columnDefinitions, studentIds) => {
    if (gridReference && gridReference.current !== undefined && gridReference.current !== null) {
        columnDefinitions.forEach(column => {
            if (column.columnType === GRID_ENUMS.USER) {
                //commented out for select all students is default
                // if(studentIds.length === 0){
                //     gridReference.current.columnApi.setColumnVisible(column.field,true);
                // }else{
                gridReference.current.api.setColumnsVisible([column.field], studentIds.includes(column.userId));
                // }
            }
        });
    }
}

export const filterQuestionColsDifficulty = (columnDefs, difficultyLevels) => {
    const updateDefs = [...columnDefs];
    updateDefs.forEach((colDef)=>{
        if(colDef.children){
            colDef.children = [...colDef.children].filter((child)=>{
                // console.log('child: ',child);
                if(child.columnType === GRID_ENUMS.TEST_TOTAL || difficultyLevels.includes(child.difficultyLevel)){
                    return child;
                }
            });
        }
    });
    // console.log('updatedColDefs: ',updateDefs);
    return updateDefs;
}

export const StudentCustomCellRenderer = props => {
    // console.log('props: ',props);
    const {callback, userId, columnType} = props.node.data;
    const onClick = () => {
        // console.log('userId: ',userId);
        // console.log('callback: ',callback);
        if (typeof callback === 'function') {
            callback(userId);
        }
    }

    return (
        <div className='flex' style={{gap:'6px', alignItems:'center'}}>
            <span>{props.value}</span>
            {columnType === GRID_ENUMS.USER && <OpenInNewIcon style={{marginTop: '8px'}} cursor='pointer' color='grey' width={16} height={16} onClick={onClick} placement={'top'}/>}
        </div>
    )
}

const StudentCustomHeader = props => {
    const {callback} = props;
    const onClick = () => {
        if (typeof callback === 'function') {
            callback(props.column.colDef.userId);
        }
    }

    return (
        <div className={'custom-header-cont'}>
            <Tooltip title={props.column.colDef.firstName + ' ' + props.column.colDef.lastName} placement="top" enterNextDelay={100}>
                <div className={'rotation-label-vert-wrapper'}>
                    <div className={'rotation-label-vert'}>{props.column.colDef.firstName}<br/>{props.column.colDef.lastName}</div>
                </div>
            </Tooltip>
            <IconButton onClick={onClick} tooltip={'Show Student Test/s'} placement={'top'}>
                <span className="material-icons">open_in_new</span>
            </IconButton>
        </div>
    )
}
export const addStudentColDefs = (students, initArr, isAggregate, callback) => {
    students.map((student) => {
        const studentFullName = (student.firstName ? student.firstName.replaceAll(' ', '\u00A0') : '') + ' ' + (student.lastName ? student.lastName.replaceAll(' ', '\u00A0') : '');
        const studentNameCol = {
            pdfExportOptions: {
                styles:{alignment: 'center'}
            },
            headerName: studentFullName,
            headerClass:'vertical-align-heading',
            field: GRID_ENUMS.USER+student.userId,
            columnType: GRID_ENUMS.USER,
            cellStyle:cellStyleCorrect,
            userId:student.userId,
            width: COL_WIDTH.RESULT,
            studentName: studentFullName,
            firstName: student.firstName,
            lastName: student.lastName,
            headerComponent: StudentCustomHeader,
            headerComponentParams: {callback: callback},
            cellRendererSelector: params => {
                const passDetails = {
                    component: 'passCellRenderer'
                };

                const failDetails = {
                    component: 'failCellRenderer'
                };

                if (params.value >= 1) {
                    return passDetails;
                }

                if (params.value === 0 || params.value === undefined) {
                    return failDetails;
                }

                return null;
            }
        };
        if(isAggregate){
            delete studentNameCol.cellRendererSelector;
            studentNameCol.cellStyle = cellStylePercentage;
            studentNameCol.cellClass = 'user-cell';
        }
        initArr.push(studentNameCol);
    });
}


export const addQuestionColDefs = (props) => {
    const {
        questions,
        columnArr,
        testAssignmentId,
        testAssignmentName,
        difficultyLevels,
        testId,
        authorName,
        assignedDate
    } = props;
    // console.log('difficultyLevels: ',difficultyLevels);
    const questionArr = [];
    let count = 1;
    let headerGroup = {headerClass:'bold-header-group' ,headerName:'Questions ('+testAssignmentName+', '+assignedDate+')', field:String(testAssignmentId)};
    questions.map((question) => {
        // console.log('question: ',question)
        const questionCol = {
            pdfExportOptions: {
                styles:{alignment: 'center'}
            },
            headerName: String(count),
            headerClass:'question-centered-header',
            field: testAssignmentId+'-'+question.questionId,
            columnType: GRID_ENUMS.QUESTION,
            cellStyle:cellStyleCorrect,
            questionId:question.questionId,
            width: COL_WIDTH.QUESTION,
            cellDataType: 'text',
            difficultyLevel:question.testDiffLevel,
            // headerComponent: StudentCustomHeader,
            headerComponentParams: {testAssignmentId: testAssignmentId, questionId:question.questionId, title:testAssignmentName+ ' > '+GRID_ENUMS.QUESTION.toLowerCase()+' '+count},
            cellRendererSelector: params => {
                const passDetails = {
                    component: 'passCellRenderer'
                };

                const failDetails = {
                    component: 'failCellRenderer'
                };

                // console.log('params: ',params);

                if(params.data.userId === '0' || params.data.userId === '-1' || params.data.userId === '-2'){ //difficulty, percent correct, and percent answered rows
                    return params.value;
                }

                if (params.value >= 1) {
                    return passDetails;
                }

                if (params.value === 0 || params.value === undefined) {
                    return failDetails;
                }

                return null;
            }
        };
        if(difficultyLevels.length === 0 || difficultyLevels.includes(question.testDiffLevel)){
            questionArr.push(questionCol);
        }
        count++;
    });
    headerGroup.children = questionArr;

    const totalQuestionCol = {
        pdfExportOptions: {
            styles:{alignment: 'center'}
        },
        headerName: 'TOTAL',
        headerClass:'question-centered-header',
        field: GRID_ENUMS.TEST_TOTAL+testAssignmentId,
        columnType: GRID_ENUMS.TEST_TOTAL,
        cellStyle:cellStyleCorrect,
        width: COL_WIDTH.QUESTION
        // headerComponent: StudentCustomHeader,
        // headerComponentParams: {callback: callback},
    };

    headerGroup.children.push(totalQuestionCol);

    columnArr.push(headerGroup);
}
